import { createSelector } from 'reselect';

const selectDeliveryDates = (state: any) => state.deliveryDates;


export const selectDeliveryDatesCurrentItem = createSelector([selectDeliveryDates], (deliveryDates) => deliveryDates.current);

export const selectDeliveryDatesListItems = createSelector([selectDeliveryDates], (deliveryDates) => deliveryDates.list);

export const selectDeliveryDatesItemById = (itemId: any) =>
    createSelector(selectDeliveryDatesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDeliveryDatesQueryItems = createSelector([selectDeliveryDates], (deliveryDates) => deliveryDates.query);

export const selectDeliveryDatesCreatedItem = createSelector([selectDeliveryDates], (deliveryDates) => deliveryDates.create);

export const selectDeliveryDatesUpdatedItem = createSelector([selectDeliveryDates], (deliveryDates) => deliveryDates.update);

export const selectDeliveryDatesReadItem = createSelector([selectDeliveryDates], (deliveryDates) => deliveryDates.read);

export const selectDeliveryDatesDeletedItem = createSelector([selectDeliveryDates], (deliveryDates) => deliveryDates.delete);

export const selectDeliveryDatesSearchedItems = createSelector([selectDeliveryDates], (deliveryDates) => deliveryDates.search);

export const selectDeliveryDatesItemsCount = createSelector([selectDeliveryDates], (deliveryDates) => deliveryDates.count);

export const selectDeliveryDatesItemsFilter = createSelector([selectDeliveryDates], (deliveryDates) => deliveryDates.filter);